module.exports = __webpack_public_path__ + "img/boxes.e66f59df.svg";